<template>
	<div class="box">
		<div class="block-title">充电增长率</div>
		<div class="boxnav" style="height: 310px; width: 100%">
			<div style="height: 300px; float: left; width: 40%; padding: 0 5px">
				<div class="tit02 text-b">充电同比</div>
				<div class="huanbi">
					<ul>
						<li>
							充电次数
							<span :class="chargeContrast.ChargeNum < chargeContrast.ChargeNumPrev ? 'text-d' : 'text-s'">{{
                chargeContrast.ChargeNum
              }}</span>
						</li>
						<li>
							充电电量
							<span :class="chargeContrast.ChargeKwh < chargeContrast.ChargeKwhPrev ? 'text-d' : 'text-s'">{{
                chargeContrast.ChargeKwh
              }}</span>
						</li>
						<li>
							充电费用
							<span :class="chargeContrast.ChargeCost < chargeContrast.ChargeCostPrev ? 'text-d' : 'text-s'">{{
                chargeContrast.ChargeCost
              }}</span>
						</li>
						<li>
							充电时长
							<span :class="chargeContrast.ChargeDuration < chargeContrast.ChargeDurationPrev ? 'text-d' : 'text-s'">{{
                chargeContrast.ChargeDuration
              }}</span>
						</li>
					</ul>
				</div>
			</div>
			<div style="height: 280px; float: left; width: 60%">
				<div class="tagcloud">
					<span v-for="(item, index) in chargeContrast.ChargingEquips" :key="index"
						:class="`b0${Math.ceil(Math.random() * 4)} co0${Math.ceil(Math.random() * 5)}`">{{ item.ConnectorNo }}</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	// import { ref } from 'vue';
	// import tagcloud from '../tagCloud.js';

	export default {
		data() {
			return {
				chargeContrast: {}
			}
		},
		methods: {
			setData(data) {
				this.chargeContrast = data;
			}
		}
	}
</script>
<style type="less" scoped>
	@import '../style.css';
@import '../animation.less';
</style>